<p-dialog [(visible)]="display" [resizable]="false" [modal]="true" [style]="{'width': '760px'}" (onHide)="hide()"
	appendTo="body" styleClass="prtg-export-dialog">
	<p-header>
		<span>Export to PRTG</span>
	</p-header>

	@if (loading) {
	<div class="mb-3">Loading PRTG agents…</div>
	}

	@if (errorMessage) {
	<div class="mb-3 text-danger">{{ errorMessage }}</div>
	}

	@if (!loading && !errorMessage && dropdownOptions.length > 0) {

	<fieldset class="prtg-panel">
		<legend>PRTG Server</legend>
		<div class="form-row">
			<label class="form-label">Server Settings:</label>
			<div class="form-input">
				<p-dropdown [options]="dropdownOptions" [(ngModel)]="selectedGuid" [style]="{'width': '100%'}"
					appendTo="body" placeholder="Select a PRTG server"
					(onChange)="onPrtgSettingsChanged()"></p-dropdown>
			</div>
			<div class="form-side-spacer"></div>
		</div>
		<div class="form-row">
			<label class="form-label">Summary:</label>
			<div class="form-input">
				<input type="text" pInputText [value]="serverSummary" readonly style="width: 100%" />
			</div>
			<div class="form-side-spacer"></div>
		</div>
	</fieldset>

	<fieldset class="prtg-panel">
		<legend>Export Settings</legend>

		<div class="form-row">
			<label class="form-label">Parent Group:</label>
			<div class="form-input">
				<input type="text" pInputText [value]="parentGroupLabel" readonly style="width: 100%"
					placeholder="(default — Local Probe)"
					(dblclick)="clearParentGroup()"
					title="Double-click to clear and fall back to Local Probe." />
			</div>
			<button type="button" pButton class="form-side-btn" label="Browse..."
				(click)="browseParentGroup()" [disabled]="!selectedGuid"></button>
		</div>

		<div class="form-row mb-3">
			<label class="form-label">Group Name:</label>
			<div class="form-input">
				<input type="text" pInputText [(ngModel)]="exportName" style="width: 100%"
					placeholder="New PRTG group/map name" />
			</div>
			<button type="button" pButton class="form-side-btn" label="Browse..."
				(click)="browseGroupName()" [disabled]="!selectedGuid"></button>
		</div>

		<div class="two-col">
			<fieldset class="prtg-panel inner">
				<legend>Group / Device Settings</legend>

				<div class="checkbox-row">
					<p-checkbox binary="true" [(ngModel)]="options.createNewGroup"
						label="Create New Group" inputId="ck-cng"></p-checkbox>
				</div>
				<div class="checkbox-row indent">
					<p-checkbox binary="true" [(ngModel)]="options.removeMissingDevices"
						label="Remove Missing Devices" inputId="ck-rmd"></p-checkbox>
				</div>
				<div class="checkbox-row indent">
					<p-checkbox binary="true" [(ngModel)]="options.createDependency"
						label="Create Dependency" inputId="ck-cdep"></p-checkbox>
				</div>
				<div class="checkbox-row indent">
					<p-checkbox binary="true" [(ngModel)]="options.exportPrtgDevicesOnly"
						label="Add PRTG Devices Only" inputId="ck-epdo"></p-checkbox>
				</div>

				<div class="checkbox-row mt-3">
					<p-checkbox binary="true" [(ngModel)]="options.exportMapOnly"
						label="Export Map Only" inputId="ck-emo"></p-checkbox>
				</div>
				<div class="checkbox-row indent">
					<p-checkbox binary="true" [(ngModel)]="options.mergeMapOnExport"
						label="Merge Map on Export" inputId="ck-mmoe"
						[disabled]="!options.exportMapOnly"></p-checkbox>
				</div>
			</fieldset>

			<fieldset class="prtg-panel inner">
				<legend>Sensor Settings</legend>

				<div class="sensor-header">
					<div class="checkbox-row">
						<p-checkbox binary="true" [(ngModel)]="options.addPingSensors"
							label="Add PING Sensors" inputId="ck-aps"></p-checkbox>
					</div>
					<div class="checkbox-row">
						<p-checkbox binary="true" [(ngModel)]="options.useTemplateTags"
							label="Use Templates" inputId="ck-utt"></p-checkbox>
					</div>
				</div>

				<div class="two-col mt-2">
					<fieldset class="prtg-panel inner">
						<legend>Exported SNMP Sensors</legend>

						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addSnmpUpTimeSensors"
								label="Add SNMP UpTime Sensors" inputId="ck-asuts"></p-checkbox>
						</div>
						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addSnmpCpuSensors"
								label="Add SNMP CPU Sensors" inputId="ck-ascs"></p-checkbox>
						</div>
						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addSnmpMemorySensors"
								label="Add SNMP Memory Sensors" inputId="ck-asms"></p-checkbox>
						</div>
						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addSnmpDiskFreeSensors"
								label="Add SNMP Disk Free Sensors" inputId="ck-asdfs"></p-checkbox>
						</div>
						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addSnmpTrafficSensors"
								label="Add SNMP Traffic/IF Sensors" inputId="ck-asts"></p-checkbox>
						</div>
						<div class="checkbox-row indent">
							<p-checkbox binary="true" [(ngModel)]="options.useSnmpIfName"
								label="Use IfName" inputId="ck-usifn"
								[disabled]="!options.addSnmpTrafficSensors"></p-checkbox>
						</div>
						<div class="checkbox-row indent">
							<p-checkbox binary="true" [(ngModel)]="options.configAllInterfacesIfUp"
								label="Configure UP Interfaces" inputId="ck-caii"
								[disabled]="!options.addSnmpTrafficSensors"></p-checkbox>
						</div>
						<div class="checkbox-row indent">
							<p-checkbox binary="true" [(ngModel)]="options.configAllPhysicalInterfaces"
								label="Configure ALL Interfaces" inputId="ck-capi"
								[disabled]="!options.addSnmpTrafficSensors"></p-checkbox>
						</div>
						<div class="checkbox-row indent">
							<p-checkbox binary="true" [(ngModel)]="options.configAllUpLinkInterfaces"
								label="Configure ALL UpLinks" inputId="ck-caui"
								[disabled]="!options.addSnmpTrafficSensors"></p-checkbox>
						</div>
						<div class="indent name-format-row">
							<label>Name Format:</label>
							<input type="text" pInputText [(ngModel)]="options.snmpIfSensorFormat"
								[disabled]="!options.addSnmpTrafficSensors" />
						</div>

						<div class="checkbox-row mt-2">
							<p-checkbox binary="true" [(ngModel)]="options.configAllApSensors"
								label="Add SNMP AP Sensors" inputId="ck-caaps"></p-checkbox>
						</div>
					</fieldset>

					<fieldset class="prtg-panel inner">
						<legend>Exported Windows/WMI Sensors</legend>

						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addWmiUpTimeSensors"
								label="Add WMI UpTime Sensors" inputId="ck-awuts"></p-checkbox>
						</div>
						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addWmiCpuSensors"
								label="Add WMI CPU Sensors" inputId="ck-awcs"></p-checkbox>
						</div>
						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addWmiMemorySensors"
								label="Add WMI Memory Sensors" inputId="ck-awms"></p-checkbox>
						</div>
						<div class="checkbox-row">
							<p-checkbox binary="true" [(ngModel)]="options.addWmiDiskSpaceSensors"
								label="Add WMI Disk Space Sensors" inputId="ck-awdss"></p-checkbox>
						</div>
					</fieldset>
				</div>
			</fieldset>
		</div>
	</fieldset>

	}

	<p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="export()" label="Export"
			[disabled]="!enableExport"></button>
		<button type="button" pButton icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
	</p-footer>

	<prtg-group-picker [(display)]="pickerVisible"
		[netViewGuid]="netViewGuid"
		[prtgSettingsGuid]="selectedGuid"
		[title]="pickerTitle"
		(onSelect)="onGroupPicked($event)"></prtg-group-picker>

</p-dialog>
